import { render, staticRenderFns } from "./OnboardingChoice.vue?vue&type=template&id=baed84b6&scoped=true&"
import script from "./OnboardingChoice.vue?vue&type=script&lang=js&"
export * from "./OnboardingChoice.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingChoice.vue?vue&type=style&index=0&id=baed84b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baed84b6",
  null
  
)

export default component.exports